module.exports = __webpack_public_path__ + "img/3-01-05-b-rd.53500ad1.svg";